import { darkTheme } from '@/shared/styles/theme/dark'
import Box from '@mui/material/Box'
import CircularProgress, { circularProgressClasses, CircularProgressProps } from '@mui/material/CircularProgress'

interface SecondarySpinnerProps extends CircularProgressProps {
  animationDuration: string
}

export const SecondarySpinner = (props: SecondarySpinnerProps) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: '#414246',
          borderRadius: '48px',
        }}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={(theme) => ({
          color: darkTheme.colors.button.primary.background,
          animationDuration: '950ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
          ...theme.applyStyles('dark', {
            color: '#308fe8',
          }),
        })}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  )
}
